// extracted by mini-css-extract-plugin
var _1 = "Otm4h";
var _2 = "QzHpd";
export { _1 as "buttonPosition", _2 as "ctaMobile" }
